import React from 'react';
import './BanterLoader.css';

export type BanterLoaderSize = 'xs' | 'sm' | 'md' | 'lg';

export interface BanterLoaderProps {
    size?: BanterLoaderSize;
    label?: string;
    className?: string;
    /** When true, centers the loader (with optional label) inside its parent. */
    centered?: boolean;
}

/**
 * Polyline "drawing" loader (Uiverse milley69 style).
 * Inherits color via `currentColor` — wrap in a `text-brand-primary` etc. parent
 * to recolor. The viewBox is fixed (200x32); width/height come from the size modifier.
 */
const LineLoaderSvg: React.FC = () => (
    <svg viewBox="0 0 200 32" preserveAspectRatio="none" aria-hidden="true">
        <polyline
            className="line-loader__back"
            points="4,16 36,4 68,28 100,4 132,28 164,4 196,16"
        />
        <polyline
            className="line-loader__front"
            points="4,16 36,4 68,28 100,4 132,28 164,4 196,16"
        />
    </svg>
);

export const BanterLoader: React.FC<BanterLoaderProps> = ({
    size = 'md',
    label,
    className = '',
    centered = false,
}) => {
    const loader = (
        <span className={`line-loader line-loader--${size}`} role="status" aria-label={label || 'Chargement…'}>
            <LineLoaderSvg />
        </span>
    );

    if (centered) {
        return (
            <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
                {loader}
                {label && <p className="text-sm text-gray-500 dark:text-gray-400">{label}</p>}
            </div>
        );
    }

    if (label) {
        return (
            <span className={`inline-flex items-center gap-2 ${className}`}>
                {loader}
                <span className="text-sm text-gray-500 dark:text-gray-400">{label}</span>
            </span>
        );
    }

    return <span className={className}>{loader}</span>;
};

export default BanterLoader;
